import { render } from "./SideNavNav.vue?vue&type=template&id=3b7571a8"
import script from "./SideNavNav.vue?vue&type=script&lang=js"
export * from "./SideNavNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Navigation/SideNavNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b7571a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b7571a8', __exports__)) {
    api.reload('3b7571a8', __exports__)
  }
  
  module.hot.accept("./SideNavNav.vue?vue&type=template&id=3b7571a8", () => {
    api.rerender('3b7571a8', render)
  })

}


export default __exports__